import {createReducer, on} from '@ngrx/store';
import {addNavigationHistory} from './router.actions';

export const historyFeatureKey = 'history' as const;

export interface HistoryState {
  history: string[];
}

function getInitialHistory(): string[] {
  const currentUrl = window.location.pathname;
  // If current HQ URL is a product detail page
  // set history to product list page to prevent errors if page is refreshed
  if (/\/products\/[\w-]+$/.test(currentUrl)) {
    const match = currentUrl.match(/^(.*\/products)\//);
    if (match) {
      return [match[1]];
    }
  }
  try {
    const stored = window.localStorage.getItem('navigationHistory');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (__e) {
    // Ignore localStorage errors
  }
  return [];
}

export const initialHistoryState: HistoryState = {history: getInitialHistory()};

const MAX_HISTORY_LENGTH = 10;

export const reducer = createReducer(
  initialHistoryState,
  on(addNavigationHistory, (state, {url}) => {
    const history = [...state.history, url];
    if (history.length > MAX_HISTORY_LENGTH) {
      history.shift();
    }
    // Persist history to localStorage
    try {
      window.localStorage.setItem('navigationHistory', JSON.stringify(history));
    } catch (__e) {
      // Ignore localStorage errors
    }
    return {
      ...state,
      history: history,
    };
  })
);

export const getNavHistory = (state: HistoryState) => state.history;
